import Clear from '@/layouts/Clear.vue';

export default {
  path: '/contract-models',
  component: Clear,
  children: [
    {
      path: '',
      name: 'contract-models',
      component: () => import('@/views/Contracts/ContractModelsList.vue'),
    },
    {
      path: ':id?',
      name: 'contract-models.form',
      component: () => import('@/views/Contracts/ContractModel.vue'),
    },
  ],
};
